// extracted by mini-css-extract-plugin
export default {"sectionContainer":"src-pages-StoreVoucher-Detail-Attribute-css-module__sectionContainer--fWTtv"};